import React from "react";
import { Box, Typography } from "@mui/material";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { ChartTooltip, OUTCOME_LABELS, OUTCOME_COLORS } from "./chartTheme";

const OutcomeMixChart = ({ data = [] }) => {
  const slices = data
    .filter((d) => d.value > 0)
    .map((d) => ({ name: OUTCOME_LABELS[d.key] || d.key, value: d.value, color: OUTCOME_COLORS[d.key] || "hsl(150, 10%, 46%)" }));

  if (slices.length === 0) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
        <Typography sx={{ fontSize: 12.5, fontFamily: "Segoe UI Regular, sans-serif, system-ui", color: "hsl(150, 10%, 46%)" }}>
          No calls in this period.
        </Typography>
      </Box>
    );
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie data={slices} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius="55%" outerRadius="80%" paddingAngle={2} stroke="none">
          {slices.map((s) => (
            <Cell key={s.name} fill={s.color} />
          ))}
        </Pie>
        <Tooltip content={<ChartTooltip />} />
        <Legend wrapperStyle={{ fontSize: 11, fontFamily: "Segoe UI Regular, sans-serif, system-ui" }} />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default OutcomeMixChart;
